module.exports = __webpack_public_path__ + "static/ibm-a9022c26ad8765ab8a5f0f4154484f5e.svg";